var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "t" },
    [
      _c("img", {
        staticClass: "swipe-icon hide-lg",
        attrs: {
          src:
            "https://flyfrontier-com-frontdoor-en-chh3dufqdpdff8h9.a02.azurefd.net/images/grid-swipe-icon.png",
          alt: "Swipe left or right to view columns"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tr header" },
        _vm._l(_vm.columns, function(column) {
          return _c(
            "div",
            {
              key: column.dataField,
              class: [
                "td",
                { disabled: column.disabled, sticky: column.sticky }
              ]
            },
            [
              _c("span", [_vm._v(_vm._s(column.header))]),
              _vm._v(" "),
              column.subHeader
                ? _c("i", [_vm._v(_vm._s(column.subHeader))])
                : _vm._e()
            ]
          )
        })
      ),
      _vm._v(" "),
      _vm._l(_vm.data, function(item, index) {
        return _c(
          "div",
          { key: index, staticClass: "tr" },
          _vm._l(_vm.columns, function(column) {
            return _c(
              "div",
              {
                key: column.dataField + "_" + index,
                class: [
                  "td",
                  {
                    sticky: column.sticky,
                    disabled: column.disabled,
                    glow:
                      !column.disabled &&
                      (column.dataField == "ibCost" ||
                        column.dataField == "mmbCost") &&
                      (index == 0 || index == 1)
                  }
                ]
              },
              [
                !column.disabled &&
                (column.dataField == "ibCost" ||
                  column.dataField == "mmbCost") &&
                (index == 0 || index == 1)
                  ? _c(
                      "div",
                      {
                        staticClass: "savings-ribbon",
                        attrs: { id: "savings-ribbon" }
                      },
                      [_vm._v("\n               BEST VALUE\n            ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                column.strikeDataField && item[column.strikeDataField]
                  ? _c("span", { staticClass: "strike-box" }, [
                      _c("span", {
                        staticClass: "strike",
                        domProps: {
                          innerHTML: _vm._s(item[column.strikeDataField])
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                item[column.dataField]
                  ? _c("span", {
                      class: {
                        bold:
                          !!column.strikeDataField &&
                          item[column.strikeDataField]
                      },
                      domProps: { innerHTML: _vm._s(item[column.dataField]) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                column.subDataField && item[column.subDataField]
                  ? _c("span", {
                      staticClass: "sub",
                      domProps: { innerHTML: _vm._s(item[column.subDataField]) }
                    })
                  : _vm._e()
              ]
            )
          })
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-624feb8c", { render: render, staticRenderFns: staticRenderFns })
  }
}